$(document).ready(function() { 
    	 
    $(".peShiner").peShiner({
    hover: false,
    duration: 1,
    angle: 15,
    size: 50,
    color: "white",
    glow: 1,
    repeat: 4.5,
    reverse: false,
    delay: 0});
    $('.add-this-to-cart').tooltip({
    track: true,
	delay: 0,
	showURL: false,
	showBody: " - ",
    positionLeft: true
});
$("#shipping").colorbox({inline:true, width:"50%", height:"40%;"});
$(".product-thumb").colorbox({transition:"fade"});
$(".pvideo").colorbox({iframe:true, innerWidth:540, innerHeight:304});
$(".pvideo_flash").colorbox({iframe:true, innerWidth:540, innerHeight:305});

});